module.exports = __webpack_public_path__ + "img/description2.c99a2c68.jpg";